import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "src/assets/colors/Colors";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import { segmentacionesService } from "src/services/unoauno/apiSegmentaciones";
import { GlobalConstants } from "src/data/GlobalConstants";
import { modalCRUDService } from "src/services/modalCRUDService";

const segmentacionesTipos = [
    { id: 0, text: 'Por Proveedor' },
    { id: 1, text: 'Alguna vez ha comprado' },
    { id: 2, text: 'Frecuencia de compra del mes' },
    { id: 3, text: 'Promedio de frecuencia de compra por mes' },
    { id: 4, text: 'Han comprado por valor de' },
    { id: 5, text: 'Frecuendia por dia de visita' },
    { id: 6, text: 'Cantidad de pedidos' },
    { id: 7, text: 'Pedido anterior' },
    { id: 8, text: 'Segmentacion / Tipologia' },
    { id: 9, text: 'Dia de visita / Segmentacion' },
    { id: 10, text: 'Por version' },
];

const FormCRUDManuales = ({ properties }) => {
    const { data: { 
        proveedor, 
        idSegmentacion, 
        nombreSegmentacion, 
        orden,
        tipo,
        tipoSegmentacion,
        subTipoSegmentacion,
        jsonSegmentacion, 
        edit, 
        reload 
    } } = properties;

    const dispatch = useDispatch();
    const methods = useForm({defaultValues: {
        nombreSegmentacion: edit ? nombreSegmentacion : "",
        orden: edit ? orden : ""
    }});

    const { control, handleSubmit, formState: { errors } } = methods;

    const onClickGuardar = async (datos) => {
        datos.orden ||= "0";

        try {
            if(edit) {
                await segmentacionesService.updateSegmentacionManual({ ...datos, idSegmentacion });
            }else {
                await segmentacionesService.saveSegmentacionManual({ ...datos, idProveedor: proveedor?.id });
            }
            
            reload(); 
            modalCRUDService.clear();

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
        } catch (error) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: "Ya existe una segmentación con el mismo nombre" } });
        }
    }

    return (
        <FormProvider {...methods}>
            <div className="px-2">
                <Tooltip className="m-0" title="Agregar" aria-label="agregar" style={{position: "absolute", right: "3.5%"}}>
                    <a onClick={handleSubmit(onClickGuardar, () => {})} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                    </a>
                </Tooltip>

                {tipo === "A" && (
                    <div className="container w-100 m-0 p-0">
                        <span className="ml-2" style={{fontSize: "13pt", fontWeight: "bold"}}>Datos a modificar</span>
                    </div>
                )}

                <div className="container w-100 mx-0 px-0 mt-2">
                    <InputForm
                        inputProps={{ control }}
                        identificador="nombreSegmentacion" 
                        label="Nombre de la Segmentación"
                        placeholder=""
                        required={true}
                        textUppercase={false}
                        className="px-2 col-7"
                        customError={errors.nombreSegmentacion ? "El campo no puede estar vacío, y su longitud máxima es de 50 caracteres" : null} rules={{ maxLength: 50}}
                        style={errors.nombreSegmentacion ? { marginBottom: 0 } : ''}
                    />

                    <InputForm
                        inputProps={{ control }}
                        identificador="orden" 
                        label="Orden"
                        placeholder=""
                        type="number"
                        required={false}
                        textUppercase={false}
                        className="px-2 col-2"
                    />
                </div>

                {tipo === "A" && (
                    <div className="container w-100 mx-0 px-0 my-3">
                        <span className="ml-2" style={{fontSize: "13pt", fontWeight: "bold"}}>Información de la segmentación</span>

                        <div className="w-100 px-3 mt-2 d-flex">
                            <strong className="ml-2" style={{fontSize: "11pt"}}>Tipo de segmentación:&nbsp;</strong>
                            <span style={{fontSize: "11pt"}}>&nbsp;&nbsp;{segmentacionesTipos.find(el => el.id == tipoSegmentacion)?.text}</span>
                        </div>

                        <div className="w-100 px-3 mt-1 d-flex">
                            <strong className="ml-2" style={{fontSize: "11pt"}}>Subtipo de segmentación: &nbsp;&nbsp;</strong>
                            <span style={{fontSize: "11pt"}}>{subTipoSegmentacion}</span>
                        </div>

                        <div className="w-100 px-3 mt-1 d-flex">
                            <strong className="ml-2" style={{fontSize: "11pt"}}>Parametros de la segmentación:</strong>
                        </div>

                        <div className="w-100 px-5">
                            {Object.entries(JSON.parse(jsonSegmentacion)).map(([key, value]) => (
                                <div className="w-100 px-2 mt-1 d-flex">
                                    <strong style={{fontSize: "11pt"}}>{key}:&nbsp;</strong>
                                    <span className="ml-2">{Array.isArray(value) ? value.join(", ") : value}</span>
                                </div>
                            ))}
                        </div>

                    </div>
                )}
            </div>
        </FormProvider>
    )
}

export default FormCRUDManuales;